import InitialState from "../reducer/InitialState";

const toplevelselectors = {};

new InitialState().keySeq().forEach((key) => {
  toplevelselectors[key] = (state, props, storePath) =>
    state.getIn(storePath).get(key);
});

export default toplevelselectors;



// WEBPACK FOOTER //
// ./src/model/subsystems/app/selectors/local.js